module.exports = __webpack_public_path__ + "static/media/castledown-heavy.5d9ec915.woff";